import { useEffect } from 'react'

export function useOnClickOutside<T extends HTMLElement>(ref: React.RefObject<T>, handler: (ev: PointerEvent) => void) {
    useEffect(() => {
        const listener = (ev: PointerEvent) => {
            const el = ref.current
            if (!el) return
            if (el.contains(ev.target as Node)) return
            handler(ev)
        }

        document.addEventListener('pointerdown', listener, true)
        return () => document.removeEventListener('pointerdown', listener, true)
    }, [ref, handler])
}
